import type { FC, LabelHTMLAttributes } from "react";

import classNames from "classnames";

import styles from "./InputLabel.module.scss";

export type InputLabelProps = LabelHTMLAttributes<HTMLLabelElement> & { labelId?: string };

export const InputLabel: FC<InputLabelProps> = ({ htmlFor, id, children, labelId }) => {
  return (
    <label htmlFor={htmlFor} id={labelId || id} className={classNames(styles.label, styles.topLabel)}>
      {children}
    </label>
  );
};
